export default {
  title01: "Aktuální počasí",
  title02: "24 hodin",
  title03: "Zobrazit 10denní předpověď počasí",
  title04: "AQI",
  title05: "Zobrazit všechny informace",
  title06: "Východ a západ slunce",
  title07: "Fáze Měsíce",
  title08: "Příští úplněk",
  title09: "Příští novoluní",
  title10: "DEN",
  title11: "NOC",
  title12: "Východ slunce",
  title13: "Západ slunce",
  title14: "Východ Měsíce",
  title15: "Západ Měsíce",
  title16: "Zdroj",
  title17: "Začátek",
  title18: "Konec",
  title19: "Použít aktuální polohu",
  title20: "Hledat město",
  title21: "Pocitová teplota",
  title22: "Pocitová teplota (stín)",
  title23: "Nyní",
  title24: "Dnes",
  title25: "NED",
  title26: "PON",
  title27: "ÚTE",
  title28: "STŘ",
  title29: "ČTV",
  title30: "PÁT",
  title31: "SOB",
  title32: "Načítání...",
  title33: "teď",
  title34: "hodinový",
  title35: "každodenní",
  title36: "slunce a měsíc",
  title37: "Kvalita ovzduší",
  title38: "Kontakt: xlf550402@gmail.com",
  title39: "Zásady ochrany osobních údajů",
  title40: "Copyright © comfortweather.com 2020 - 2024. Všechna práva vyhrazena.",
  title41: "Data poskytována",
  title42: "Vysoký",
  title43: "Nízký",
  title44: "Přijmout",
  title45:
    "Děkujeme, že používáte ComfortWeather! Pro lepší ochranu vašich práv a zájmů si před použitím pečlivě přečtěte ",
  title46: "Zásady ochrany osobních údajů",
  title47: " .",
  title48: "",
  title49: "Kontakt: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2024. Všechna práva vyhrazena.",
  title51: "Děkujeme, že používáte 24hweather! Pro lepší ochranu vašich práv a zájmů si před použitím pečlivě přečtěte ",
};
